import BaseModal from "./BaseModal.vue";
import { uniqueId } from "lodash-es";

const LARGE = "lg";
const SMALL = "sm";

let Vue;

const Plugin = {
  install(_Vue) {
    this.rootInstance = null;

    if (Vue && _Vue === Vue) {
      return;
    }
    Vue = _Vue;

    Vue.component("BaseModal", BaseModal);

    Vue.mixin({
      beforeMount() {
        if (Plugin.rootInstance === null) {
          Plugin.rootInstance = this.$root;
        }
      },
      beforeCreate() {
        this._stackModais = [];
      },
      methods: {
        $registrarModal(modal) {
          this._stackModais.push(modal);
          return modal;
        }
      },
      beforeRouteLeave(to, from, next) {
        this._stackModais.forEach(modal => {
          if (modal.isAtivo && !modal.keepAlive && modal.dispensar) {
            modal.dispensar();
          }
        });
        next();
      }
    });
  }
};

export function Modal(component, input, options = {}) {
  return _launchModal(component, input, options);
}

export function ModalGrande(component, input, options = {}) {
  options.size = LARGE;
  return _launchModal(component, input, options);
}

export function ModalPequeno(component, input, options = {}) {
  options.size = SMALL;
  return _launchModal(component, input, options);
}

function _launchModal(component, input, options = {}) {
  if (Vue == null) {
    throw new Error("Install Modal: Vue.use(ModalPlugin)");
  }

  const modalNodes = _createModalNodes();

  const modalInstance = _createModalInstance(component, input, options);
  modalInstance.vm.$mount(modalNodes.modalNode);

  const modalPromise = modalInstance.promise
    .then(output => {
      _destroyModal(modalNodes, modalInstance.vm);
      modalInstance.isAtivo = false;
      return output;
    })
    .catch(output => {
      _destroyModal(modalNodes, modalInstance.vm);
      modalInstance.isAtivo = false;
      return Promise.reject(output);
    });

  modalPromise.keepAlive = options.keepAlive;
  modalPromise.isAtivo = true;
  modalPromise.modal = modalInstance.vm;
  modalPromise.fechar = modalInstance.fecharFn;
  modalPromise.dispensar = modalInstance.dispensarFn;

  return modalPromise;
}

function _destroyModal(modalNodes, vm) {
  vm.$destroy();
  document.body.removeChild(modalNodes.modalContainer);
  document.body.removeChild(modalNodes.backdrop);
  document.body.style.overflow = "auto";
}

function _createModalInstance(component, input, options) {
  let fecharFn;
  let dispensarFn;

  const modalPromise = new Promise((resolve, reject) => {
    fecharFn = resolve;
    dispensarFn = reject;
  });
  const root = options && options.root ? options.root : Plugin.rootInstance;
  const vm = new Vue({
    parent: root,
    render(h) {
      return h(BaseModal, {
        attrs: {
          options: this.options,
          input: this.input,
          component: this.component
        },
        on: {
          fechar: this.onFechar,
          dispensar: this.onDispensar
        }
      });
    },
    data() {
      return {
        options,
        input,
        component
      };
    },
    methods: {
      onFechar: fecharFn,
      onDispensar: dispensarFn
    }
  });

  return {
    vm,
    fecharFn,
    dispensarFn,
    promise: modalPromise
  };
}

function _createModalNodes() {
  const backdrop = _createBackdrop();
  document.body.appendChild(backdrop);
  const modalContainer = _createDivWithId("modal-container-");
  const modalNode = _createDivWithId("modal-node-");
  modalContainer.appendChild(modalNode);
  document.body.appendChild(modalContainer);
  document.body.style.overflow = "hidden";

  return {
    backdrop,
    modalContainer,
    modalNode
  };
}

function _createDivWithId(prefix) {
  const div = document.createElement("div");
  div.setAttribute("id", uniqueId(prefix));
  return div;
}

function _createBackdrop() {
  const backdrop = document.createElement("div");
  backdrop.setAttribute("class", "modal-backdrop fade show");
  return backdrop;
}

export default Plugin;
